var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthChain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C7.5815 20 4 16.4185 4 12C4 7.5815 7.5815 4 12 4C16.4185 4 20 7.5815 20 12C20 16.4185 16.4185 20 12 20ZM15.997 12.1095L12.249 6L8.5 12.11L12.249 14.2865L15.997 12.1095ZM16 12.808L12.249 14.9835L8.5 12.8085L12.249 17.9975L16 12.808Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.248 6V10.435L15.9965 12.11L12.248 6ZM12.248 14.984V17.9975L15.999 12.808L12.248 14.984Z",
    fill: "currentColor",
    fillOpacity: 0.298
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.248 14.2865L15.9965 12.11L12.248 10.436V14.2865Z",
    fill: "currentColor",
    fillOpacity: 0.801
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.11L12.249 14.2865V10.436L8.5 12.11Z",
    fill: "currentColor",
    fillOpacity: 0.298
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthChain);
export default __webpack_public_path__ + "static/media/eth-chain.b24e35233bb2ba73a1c2d68fc164e0d9.svg";
export { ForwardRef as ReactComponent };